import { combineReducers } from 'redux';
import offers from './offersReducer';
import marketplaceServiceability from './marketplaceServiceabilityReducer';
import marketPlacePincodeReducer from './marketPlacePincodeReducer';
export default combineReducers({
    offers,
    marketplaceServiceability,
    marketPlacePincodeReducer
});
